import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, Tabs } from 'antd';
import { Table, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { ICourseDefinition, listCourseDefinitions, createCourseDefinition, updateCourseDefinition, deleteCourseDefinition, pageCourseDefinitions } from '../../service/api/courseDefinition';
import moment from 'moment';
import { FormInstance } from 'antd/lib/form/Form';
const { confirm } = Modal;

interface ICourseDefinitionListProps {
  visible: boolean
  setVisible: (visible: boolean) => void;
}
const CourseDefinitionList: React.FC<ICourseDefinitionListProps> = ({
  visible,
  setVisible,
}) => {
  const [courseDefinitions, setCourseDefinitions] = useState<ICourseDefinition[]>();
  const [courseDefinitionDetail, setCourseDefinitionDetail] = useState<ICourseDefinition>();
  const [pageNum, setPageNum] = useState(1);
  const [pageTotal, setPageTotal] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const formRef = React.createRef<FormInstance>();
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: '名称',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
    },
    {
      title: '单价',
      dataIndex: 'unitPrice',
      key: 'unitPrice',
    },
    {
      title: '操作',
      key: 'action',
      render: (text: any, record: any) => {
        return <Space size="middle">
          <a onClick={() => {
            setVisible(true);
            setCourseDefinitionDetail(record);
          }}>编辑 </a>
        </Space>
      },
    }
  ];

  useEffect(() => {
    loadData();
  }, [pageNum, pageSize]);

  useEffect(() => {
    if (courseDefinitionDetail) {
      // 设置100毫秒的延迟 确保from组件已经加载完毕
      setTimeout(() => {
        formRef.current!.setFieldsValue(courseDefinitionDetail);
      }, 100);
    }
  }, [courseDefinitionDetail]);

  const loadData = () => {
    pageCourseDefinitions(pageNum, pageSize).then((info: any) => {
      setCourseDefinitions(info?.data.list);
      setPageTotal(info?.data.total);
    });
  }

  const onFinish = (values: any) => {
    setLoading(true);
    if (courseDefinitionDetail) {
      updateCourseDefinition({
        ...values,
        id: courseDefinitionDetail.id
      }).then((info: any) => {
        console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("更新成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    } else {
      createCourseDefinition(values).then((info: any) => {
        console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("创建成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    }
  };

  // const onDelete = (e: any, item: ICourseDefinition) => {
  //   e.stopPropagation();
  //   confirm({
  //     title: '提示',
  //     icon: <ExclamationCircleOutlined />,
  //     content: '确定要删除该课程吗？删除后无法恢复',
  //     okText: '确定',
  //     okType: 'danger',
  //     cancelText: '取消',
  //     onOk() {
  //       deleteCourseDefinition(item.id).then((info: any) => {
  //         console.log("info:" + JSON.stringify(info));
  //         message.success("删除成功");
  //         loadData();
  //       });
  //     },
  //     onCancel() {
  //     },
  //   });
  // }

  const onClose = () => {
    setCourseDefinitionDetail(undefined);
    setVisible(false);
    if (formRef.current) {
      formRef.current!.resetFields();
    }
  }

  const onPageChange = (pageNum: number, pageSize?: number) => {
    console.log("pageNum:" + pageNum);
    console.log("pageSize:" + pageSize);
    setPageNum(pageNum);
    setPageSize(pageSize || 10);
    // setPageSize(info.data.pageSize);
  }

  return (
    <Card bordered={false}>
      <Table dataSource={courseDefinitions} columns={columns} pagination={false} />
      <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "10px" }}>
        <Pagination
          defaultCurrent={pageNum}
          total={pageTotal}
          pageSize={pageSize}
          hideOnSinglePage={false}
          className="pagination"
          onChange={onPageChange}
          showSizeChanger
          showTotal={total => `共计 ${total} 条`}
        />
      </div>
      <Drawer
        title={courseDefinitionDetail ? "编辑课程" : "新增课程"}
        visible={visible}
        width={720}
        onClose={onClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={onFinish} ref={formRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="名称"
                rules={[{ required: true, message: '请输入名称' }]}
              >
                <Input placeholder="请输入名称" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="unitPrice"
                label="单价"
                rules={[{ required: true, message: '请输入单价' }]}
              >
                <Input placeholder="请输入单价" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="remark"
                label="备注"
                rules={[{ required: true, message: '请输入备注' }]}
              >
                <Input placeholder="请输入备注" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>保存</Button>
                <Button htmlType="button" onClick={onClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </Card>
  );
};

export default CourseDefinitionList;
